module.exports = __webpack_public_path__ + "img/4-6-tour-3.7ec177e5.jpg";